<template>
    <div>
         <el-row class='tab'>
            <div style="margin-top:10px;">
                 <!-- 订单报表 -->    
                <el-table :data="viewData"   style="width:210mm"  width='200mm' class="table_data" v-if='activeName==0'  border> 
                    <el-table-column  prop="productionOrderCode" min-width="10%" label="生产单号" ></el-table-column>
                    <el-table-column  prop="orderCode" label="订单号" min-width="10%"></el-table-column>
                    <!-- <el-table-column  prop="materialName" label="物料名称" min-width="10%"></el-table-column> -->
                    <el-table-column  prop="materialCode" label="物料编码" min-width="10%"></el-table-column>
                    <el-table-column  prop="planCount" label="物料生产总数" min-width="10%" ></el-table-column>
                    <el-table-column  prop="finishedCount" label="已完成数量" min-width="10%" ></el-table-column>
                    <el-table-column  prop="currentFinishedCount" label="期间完成数量" min-width="10%" ></el-table-column>
                    <!-- <el-table-column  prop="process" label="进度" :formatter="parseRatio" min-width="6%" ></el-table-column> -->
                    <el-table-column  prop="procedureName" label="工序名称" min-width="10%"></el-table-column>
                    <el-table-column prop="deviceCode"  label="设备编号" min-width="10%"></el-table-column>
                    <el-table-column prop="workerName" label="员工名称" min-width="10%"></el-table-column>
                    <el-table-column prop="userFinishedCount" label="完成数量" min-width="10%"></el-table-column>
                </el-table>

                 <!-- 设备报表 -->
                <el-table :data="viewData" style="width:190mm"  width='190mm'  class="table_data" v-else-if='activeName==1' border >
                    <el-table-column  prop="deviceCode" min-width="17%" label="设备编号" ></el-table-column>
                    <el-table-column prop="runTime" min-width="10%"  label="运行时间" :formatter="parseRunTime" ></el-table-column>
                    <el-table-column prop="stopTime" min-width="10%"  label="停机时间" :formatter="parseStopTime" ></el-table-column>
                    <el-table-column  prop="name" min-width="15%" label="零件/产品名称" ></el-table-column>
                     <el-table-column prop="count" min-width="12%" :formatter="parseCount" label="期间加工数量" ></el-table-column>
                    <el-table-column prop="orderCode" min-width="17%" label="关联订单" ></el-table-column>
                    <el-table-column prop="userName" min-width="15%"  label="操作人" ></el-table-column>
                </el-table>

                 <!-- 工人报表 -->
                <el-table :data="viewData" style="width:190mm"  width='190mm' class="table_data" v-else-if="activeName==2"  border>
                    <el-table-column  prop="workerName" label="工人名称" ></el-table-column>
                    <el-table-column prop="partCode" label="物料编码" ></el-table-column>
                    <el-table-column prop="partName"  label="物料名称" ></el-table-column>
                    <el-table-column prop="deviceName" label="设备" ></el-table-column>
                    <el-table-column prop="procedureName"  label="工序" ></el-table-column>
                    <el-table-column  prop="partCount" label="计划生产物料数" ></el-table-column>
                    <el-table-column prop="qualifiedProcessCount"  label="实际生产物料数" ></el-table-column>
                    <el-table-column prop="currentPartCount"  label="期间生产物料数" ></el-table-column>
                </el-table>
            </div>
        </el-row>
    </div>
</template>
<script>
export default {
    name: "PrintReport",
    props: {
        viewData:Array,
        activeName:String
	},
    data() {
        return {
        
        progressData:[]
        
        };
    },
    mounted() {
    },
    methods:{
        objectSpanMethod({ row, column, rowIndex, columnIndex }){
            if (columnIndex<4) {
                if (row.len) {
                    return {
                        rowspan: row.len,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
        reload(){
            log('reload',this.viewData)
            this.$forceUpdate()
        },
        parseOrderDate:function(time){
            if(time != null){
                let dateString = commonUtils.timestampToDate(time.orderTime,true);
                return dateString;
            }
        },
        parseType:function(row){
            if(row.materialType==1){
                return '产品'
                
            }else if(row.materialName==2){
                return '零件'
            }else{
                return ''
            }
        },
        parseRatio:function(rowData){
            if(rowData.process != null){
                return rowData.process+'%';
            }
        },
        parseRunTime(rowData){
            return commonUtils.secondToDate(rowData.runTime)
        },
        parseStopTime(rowData){
            return commonUtils.secondToDate(rowData.stopTime)
        },
        parseCount(rowData){
            log(rowData.count)
            if(!rowData.count){
                return 0
            }else{
                return rowData.count
            }
        }
    }
}

</script>
<style>
@media print{
    .label{

    }
    .value{
        display: inline-block;
        width: 200px;
        height: 32px;
        line-height: 32px;
        font-size: 12px;
        color: #606266;
        
    }
}

</style>




// WEBPACK FOOTER //
// src/views/report/PrintReport.vue